export default __webpack_public_path__ + "static/3-3f0af83a4b529e8e1683c9bc7009f767.webp";